<template lang="pug">
  span.time-ago {{timeAgo(date)}}

</template>
<script>
import timeago from 'timeago.js'
import { gettext } from '@/services/TranslateHandler'
export default {
  name: 'TimeAgo',
  props: {
    date: {
      default: ''
    }
  },
  methods: {
    timeAgo (val) {
      let gettextLocal = (number, index, total) => {
        return [
          [gettext('just now'), gettext('right now')],
          [gettext('%s seconds ago'), gettext('in %s seconds')],
          [gettext('1 minute ago'), gettext('in 1 minute')],
          [gettext('%s minutes ago'), gettext('in %s minutes')],
          [gettext('1 hour ago'), gettext('in 1 hour')],
          [gettext('%s hours ago'), gettext('in %s hours')],
          [gettext('1 day ago'), gettext('in 1 day')],
          [gettext('%s days ago'), gettext('in %s days')],
          [gettext('1 week ago'), gettext('in 1 week')],
          [gettext('%s weeks ago'), gettext('in %s weeks')],
          [gettext('1 month ago'), gettext('in 1 month')],
          [gettext('%s months ago'), gettext('in %s months')],
          [gettext('1 year ago'), gettext('in 1 year')],
          [gettext('%s years ago'), gettext('in %s years')]
        ][index]
      }
      timeago.register('gettextLocal', gettextLocal)
      if (val) {
        return timeago().format(val, 'gettextLocal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/time-ago/index.vue